
import { App } from './App';
import './index.scss';

export default PLCTest;

function PLCTest() {
    return (<App></App>);
}
